export default __webpack_public_path__ + "static/0-6af7e9c31308845d08743b03cf5ca17d.jpg";